
export const analyticsStats: AnalyticsStat[] = [
  { id: "visitors", label: "Visitors", value: "124.5k", change: "+18.2%", bg: "bg-primary-soft", color: "text-primary" },
  { id: "pageviews", label: "Page Views", value: "892k", change: "+12.8%", bg: "bg-purple-soft", color: "text-purple" },
  { id: "bounce", label: "Bounce Rate", value: "32.4%", change: "-4.1%", bg: "bg-pink-soft", color: "text-pink" },
  { id: "duration", label: "Avg. Duration", value: "4m 32s", change: "+8.5%", bg: "bg-teal-soft", color: "text-teal" },
];

export const trafficData: TrafficPoint[] = [
  { day: "Mon", visitors: 4200, pageViews: 12400 },
  { day: "Tue", visitors: 5100, pageViews: 15200 },
  { day: "Wed", visitors: 4800, pageViews: 14100 },
  { day: "Thu", visitors: 6200, pageViews: 18600 },
  { day: "Fri", visitors: 5800, pageViews: 17200 },
  { day: "Sat", visitors: 3900, pageViews: 11500 },
  { day: "Sun", visitors: 3400, pageViews: 9800 },
];

export const trafficSources: TrafficSource[] = [
  { name: "Organic", value: 45, color: "#4680ff" },
  { name: "Direct", value: 25, color: "#13c2c2" },
  { name: "Social", value: 18, color: "#ffb800" },
  { name: "Referral", value: 12, color: "#ff5a87" },
];

export const topPages: TopPage[] = [
  { path: "/homepage", views: 45200, bounce: "28%" },
  { path: "/pricing", views: 32100, bounce: "35%" },
  { path: "/blog", views: 28400, bounce: "42%" },
  { path: "/about-us", views: 19800, bounce: "38%" },
  { path: "/contact-us", views: 15600, bounce: "45%" },
];

export const deviceData: DeviceData[] = [
  { device: "Desktop", value: 58 },
  { device: "Mobile", value: 35 },
  { device: "Tablet", value: 7 },
];
